import React from "react";
import {Typography} from "@mui/material";
import ProductCodeSplitterSelect from "./product-code-splitter-select";
import {useProductCodeSplitter} from "./use-product-code-splitter";

const ProductCodeSplitterControlled = ({
                                           value,
                                           onChange,
                                           disabled = false,
                                           column = false,
                                           description,
                                           label = 'Code Splitter',
                                       }) => {
    const {splitter, loading, changeSplitter} = useProductCodeSplitter({value, onChange});

    return (
        <div className={`d-flex ${column ? 'flex-column' : 'flex-row'} align-items-center w-100`} style={{gap: 12}}>
            {
                description &&
                <Typography variant={'body2'} className={'text-center placeholder-text mb-0'}>
                    {description}
                </Typography>
            }
            <ProductCodeSplitterSelect
                value={splitter}
                onChange={changeSplitter}
                disabled={disabled}
                loading={loading}
                label={label}
            />
        </div>
    );
};

export default ProductCodeSplitterControlled;
